import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress, Grid, IconButton, ToggleButton, ToggleButtonGroup,
    Tooltip,
    Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {getAddresse, getDataInString} from "../RightAccordion";
import IconesRight from "../../pages/compos/IconesRight";
import InfoIcon from "@mui/icons-material/Info";
import IconMaison from "../../ico/IconMagasin";
import LocalParkingIcon from "@mui/icons-material/LocalParking";
import AspectRatioIcon from "@mui/icons-material/AspectRatio";
import HeightIcon from "@mui/icons-material/Height";
import IconEtage2 from "../../ico/IconEtage2";
import IconMSquare2 from "../../ico/IconMSquare2";
import IconMur from "../../ico/IconMur";
import IconToit from "../../ico/IconToit";
import {resBdnb} from "../AttributBdnb";
import FlatBar3 from "../FaltBar3";
import {getDpeColor, getMaxDpeValue} from "../../pages/dpeByIris/MapPage";
import {mergeValuesAndLabels, resDpeV2} from "../AttributDpeV2";
import FlatDpe from "../FaltDpe";
import {resDpeV1} from "../AttributDpeV1";
import DpeV2Details from "./DpeV2Details";
import DpeTerDetails from "./DpeTerDetails";
import DpeV1Details from "./DpeV1Details";
import DpeV2ImmeubleDetails from "./DpeV2ImmeubleDetails";
import DpeV2NewDetails from "./DpeV2NewDetails";


export default function DpeDetails({selectedItem}) {

    const [vue, setVue] = React.useState(selectedItem.dpeV2.length > 0 ? "dpeV2" : selectedItem.listOfDpeV1.length > 0 ? "dpeV1" : "dpeTer");

    return (<Box sx={{
            width: "95%",
            borderRadius: "8px",
            backgroundColor: "#f7f9fc",
            padding: 2
        }}>
            <Box sx={{width: "95%"}}>
                <ToggleButtonGroup
                    value={vue}
                    exclusive={true}
                    onChange={(e, value) => {
                        if (value) {
                            setVue(value);
                        }
                    }}
                    fullWidth={true}
                >
                    <ToggleButton value="dpeV2Immeuble" sx={{display: "flex", alignItems: "center", gap: 2}}
                                  disabled={selectedItem.listOfDpesV2Immeuble.length === 0}>
                        <Typography>

                            DPE immeuble opposables après Juil 2021
                        </Typography>
                        <Box sx={{width: "40%"}}>
                            {selectedItem.listOfDpesV2Immeuble.length > 0 && <Box width={{
                                width: 40,
                                height: 20,
                                backgroundColor: getDpeColor(getMaxDpeValue(selectedItem.listOfDpesV2Immeuble, "etiquette_dpe")),
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 5
                            }}>
                                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2">
                                    {getMaxDpeValue(selectedItem.listOfDpesV2Immeuble, "etiquette_dpe")}
                                </Typography>
                            </Box>}
                        </Box>
                    </ToggleButton>
                    <ToggleButton value="dpeV2" sx={{display: "flex", alignItems: "center", gap: 2}}
                                  disabled={selectedItem.dpeV2.length === 0}>
                        <Typography>

                            DPE opposables après Juil 2021
                        </Typography>
                        <Box sx={{width: "40%"}}>
                            {selectedItem.dpeV2.length > 0 && <Box width={{
                                width: 40,
                                height: 20,
                                backgroundColor: getDpeColor(getMaxDpeValue(selectedItem.dpeV2, "etiquette_dpe")),
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 5
                            }}>
                                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2">
                                    {getMaxDpeValue(selectedItem.dpeV2, "etiquette_dpe")}
                                </Typography>
                            </Box>}
                        </Box>
                    </ToggleButton>
                    <ToggleButton value="dpeTer" sx={{display: "flex", alignItems: "center", gap: 2}}
                                  disabled={selectedItem.dpeTer.length === 0}>

                        <Typography>

                            DPE Ter
                        </Typography>
                        {selectedItem.dpeTer.length > 0 && <Box sx={{width: "40%"}}>
                            <Box width={{
                                width: 40,
                                height: 20,
                                backgroundColor: getDpeColor(getMaxDpeValue(selectedItem.dpeTer, "etiquette_dpe")),
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 5
                            }}>
                                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2">
                                    {getMaxDpeValue(selectedItem.dpeTer, "etiquette_dpe")}
                                </Typography>
                            </Box>
                        </Box>}
                    </ToggleButton>
                    <ToggleButton value="dpeV2New" sx={{display: "flex", alignItems: "center", gap: 2}}
                                  disabled={selectedItem.listOfdpeNew.length === 0}>

                        <Typography>

                            DPE nouveau
                        </Typography>
                        {selectedItem.listOfdpeNew.length > 0 && <Box sx={{width: "40%"}}>
                            <Box width={{
                                width: 40,
                                height: 20,
                                backgroundColor: getDpeColor(getMaxDpeValue(selectedItem.listOfdpeNew, "etiquette_dpe")),
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 5
                            }}>
                                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2">
                                    {getMaxDpeValue(selectedItem.listOfdpeNew, "etiquette_dpe")}
                                </Typography>
                            </Box>
                        </Box>}
                    </ToggleButton>

                    <ToggleButton value="dpeV1" sx={{display: "flex", alignItems: "center", gap: 2}}
                                  disabled={selectedItem.listOfDpeV1.length === 0}>
                        <Typography>

                            DPE non opposables av Juil 2021
                        </Typography>
                        <Box sx={{width: "40%"}}>
                            {selectedItem.listOfDpeV1.length > 0 && <Box width={{
                                width: 40,
                                height: 20,
                                backgroundColor: getDpeColor(getMaxDpeValue(selectedItem.listOfDpeV1, "classe_conso_energie_arrete_2012")),
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: 5
                            }}>
                                <Typography sx={{fontWeight: 500}} color={"#000"} variant="body2">
                                    {getMaxDpeValue(selectedItem.listOfDpeV1, "classe_conso_energie_arrete_2012")}
                                </Typography>
                            </Box>}
                        </Box>
                    </ToggleButton>

                </ToggleButtonGroup>
            </Box>
            {vue === "dpeV2" && <DpeV2Details selectedItem={selectedItem}/>}
            {vue === "dpeTer" && <DpeTerDetails selectedItem={selectedItem}/>}
            {vue === "dpeV1" && <DpeV1Details selectedItem={selectedItem}/>}
            {vue === "dpeV2Immeuble" && <DpeV2ImmeubleDetails selectedItem={selectedItem}/>}
            {vue === "dpeV2New" && <DpeV2NewDetails selectedItem={selectedItem}/>}
        </Box>
    )
}

